import Reflux       from 'reflux';
import Actions      from '../../actions';
import _            from 'lodash';
import Utils        from "../../Utils/Utility";

const DELIVERY = "Delivery";
const PICKUP = "PickUp";
const CURBSIDEPICKUP = "CurbsidePickUp";
const DINEIN = "DineIn";

module.exports = Reflux.createStore({
    listenables : [Actions],
    init() {
        this._chargeConfig    = [];
        // this._deliveryCharges = [];
        // this._pickupCharges   = [];
        // this._curbsidePickupCharges = [];
        // this._dineInCharges         = [];
        // this._orderTypes = ["Delivery","PickUp","CurbsidePickUp","DineIn"];
        // this._deliveryEmptyObj=["charge1","charge2","charge3"];
        // this._pickUpEmptyObj=["charge1","charge2","charge3"];
        // this._curbsidePickUpEmptyObj=["charge1","charge2","charge3"];
        // this._dineInEmptyObj=["charge1","charge2","charge3"];
        // this._deliveryRoundUp=false;
        // this._pickUpRoundUp=false;
        // this._curbsidePickUpRoundUp=false;
        // this._dineInRoundUp=false;
    },

    // get locationDetailPointer object
    onMainDataCustom(locationDetail) {

        let self = this;
        // Clear the custom charge state
        self.clearCustomChargeStore();

        if (locationDetail) {

            let chargeConfig = locationDetail.chargeConfig;
            if (chargeConfig && chargeConfig.length > 0){

                // load the custom charges
                self._chargeConfig = chargeConfig;

                // Filter the custom charge data with order type
                // self.filterCustomCharges();
            }
        }
    },

    filterCustomCharges(){

        let self = this;
        let orderTypes = this._orderTypes;

        orderTypes.forEach(function (element) {

            let filteredCharges = self.arrangeByOrderType(element);

            // self.filterOrderTypeEmptyObj(filteredCharges, element);

            if (element == DELIVERY) {
                self._deliveryCharges = filteredCharges;
            }
            else if (element == PICKUP) {
                self._pickupCharges = filteredCharges;
            }
            else if (element == CURBSIDEPICKUP) {
                self._curbsidePickupCharges = filteredCharges;
            }
            else if (element == DINEIN) {
                self._dineInCharges = filteredCharges;
            }
            else {
                // not found any order type
            }
        });

    },

    arrangeByOrderType(type){

        let self = this;

        // get the charge config array of charges
        let chargeConfig = self._chargeConfig;

        // filter the charges based on order types and active status
        var filteredArray = chargeConfig.filter(function(charge){

            // let status = charge.active;
            // if (status){
                let orderTypes = charge.orderTypes;

                return orderTypes.some(function(orderType) {
                    return orderType == type;
                });
            // }

        });

        return filteredArray;

    },

    getCustomCharges(){

        let self = this;

        let customCharges = self._chargeConfig;
        if (customCharges.length > 0){
            return customCharges;
        }
        else {
            return null
        }

    },


    checkChargeTagExist(tag, chargeId){

        let customCharges = this.getCustomCharges();

        if (customCharges != null){

            let tagName = tag.trim();

            let chargeIndex = null;
            if (!Utils.isEmpty(chargeId)){

                // find the charge based on the tag
                chargeIndex = customCharges.findIndex(function(charge){
                    return (charge.tag == tagName && charge.chargeId != chargeId)
                });
            }
            else {
                // find the charge based on the tag
                chargeIndex = customCharges.findIndex(function(charge){ return charge.tag == tagName});
            }
            // if charge exist then return the true otherwise false
            if (chargeIndex != -1){
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }

    },

    isRoundUpExits(chargeId){

        let customCharges = this.getCustomCharges();

        if (customCharges != null){

            let chargeType = "R";

            let chargeIndex = null;
            if (!Utils.isEmpty(chargeId)){

                // find the charge based on the type = R
                chargeIndex = customCharges.findIndex(function(charge){
                    return (charge.type == chargeType && charge.chargeId != chargeId)
                });
            }
            else {
                // find the charge based on the type = R
                chargeIndex = customCharges.findIndex(function(charge){ return charge.type == chargeType});
            }
            // if charge exist then return the true otherwise false
            if (chargeIndex != -1){
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }


    },
    clearCustomChargeStore(){
        this._chargeConfig    = [];
        // this._deliveryCharges = [];
        // this._pickupCharges = [];
        // this._curbsidePickupCharges = [];
        // this._dineInCharges = [];
        // this._deliveryEmptyObj=["charge1","charge2","charge3"];
        // this._pickUpEmptyObj=["charge1","charge2","charge3"];
        // this._curbsidePickUpEmptyObj=["charge1","charge2","charge3"];
        // this._dineInEmptyObj=["charge1","charge2","charge3"];
        // this._deliveryRoundUp=false;
        // this._pickUpRoundUp=false;
        // this._curbsidePickUpRoundUp=false;
        // this._dineInRoundUp=false;

    },

    // triggerCustomChargesChange() {
    //
    //     const customChargeObj = {
    //         // deliveryCharges         : this._deliveryCharges,
    //         // pickupCharges           : this._pickupCharges,
    //         // curbsidePickupCharges   : this._curbsidePickupCharges,
    //         // dineInCharges           : this._dineInCharges,
    //         // fixedChargeValue        : this._fixedChargeValue,
    //         // // defaultOptionalCharge   : this._defaultOptionalCharge,
    //         // appliedCharge1          : this._appliedCharge1,
    //         // appliedCharge2          : this._appliedCharge2,
    //         // appliedCharge3          : this._appliedCharge3,
    //         // roundOffStatus          : this._roundOffStatus,
    //         // roundOffValue          : this._roundOffValue
    //     };
    //     this.trigger('change', customChargeObj);
    // }
});




// WEBPACK FOOTER //
// src/components/stores/custom-charge-store.jsx